import { Navigate } from "react-router";
import { useGetUserQuery } from "../../../apis/User.api";
import { PrimaryUser, User } from "../../../types/models/User";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const UserScoped = () => {
    const {
        data,
    } = useGetUserQuery(PrimaryUser.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/users/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default UserScoped;
